import React, { useRef } from "react";
import LeftHeader from './LeftHeader';
import MyHeader from "./Header.module.css";
import RightHeader from './RightHeader';

const Header = ({ isMobile }) => {
  const leftRef = useRef();
  const leftActionsRef = useRef();

  return (
    <div className="my-header">
      <div className={MyHeader.headerMain} style={{ marginBottom: 2 }}>
        <div className={MyHeader.headerTopRow}>
          <LeftHeader isMobile={isMobile} leftRef={leftRef} leftActionsRef={leftActionsRef} />
            <RightHeader isMobile={isMobile} leftRef={leftRef} leftActionsRef={leftActionsRef} />
        </div>
      </div>
    </div>
  );
};

export default Header;
